import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IPublicRestaurant, Label, MessageType } from '@localina/core';
import { Message } from '../../../components';

interface IProps {
    restaurant: IPublicRestaurant;
    onNext: () => void;
}

export const Welcome: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    return (
        <>
            <Label type="title" value={t('reservation.welcome.title')} variant="h5" />
            <Message restaurant={props.restaurant} type={MessageType.WELCOME} />
            <div className="grow" />
            <div className="buttons">
                <Button label={t('common.buttons.next')} onClick={props.onNext} />
            </div>
        </>
    );
};
